import { enUS as coreEnUS, jaJP as coreJaJP } from "@mui/material/locale";
import { enUS as gridEnUS, jaJP as gridJaJP } from "@mui/x-data-grid/locales";
import {
  enUS as pickersEnUS,
  jaJP as pickersJaJP,
} from "@mui/x-date-pickers/locales";
import { LANGUAGEMAP } from "../constants";

type LocaleKey = (typeof LANGUAGEMAP.mui)[keyof typeof LANGUAGEMAP.mui];

const coreLocales: Record<LocaleKey, typeof coreEnUS> = {
  enUS: coreEnUS,
  jaJP: coreJaJP,
};
const gridLocales: Record<LocaleKey, typeof gridEnUS> = {
  enUS: gridEnUS,
  jaJP: gridJaJP,
};
const pickersLocales: Record<LocaleKey, typeof pickersEnUS> = {
  enUS: pickersEnUS,
  jaJP: pickersJaJP,
};

export function getMuiLocaleBundles(language: string) {
  const localeKey = (LANGUAGEMAP.mui[language] ?? "enUS") as LocaleKey;
  return {
    core: coreLocales[localeKey] ?? coreEnUS,
    grid: gridLocales[localeKey] ?? gridEnUS,
    pickers: pickersLocales[localeKey] ?? pickersEnUS,
  };
}
